// extracted by mini-css-extract-plugin
export default {"searchPage":"SearchPage_searchPage__xhhZL","title":"SearchPage_title__UJjad","searchSection":"SearchPage_searchSection__ggaDX"};